module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/casestudy-img-01-a6ff154b092cdb011f0aa72176a23958.png";